module.exports = (__parcel__import__("bgvcG")).then(() => parcelRequire('lmhgI'));